
import PropTypes from 'prop-types'
import React from 'react'
import Overlay from './Overlay'
import Confirm from './Confirm'
import { Radio, Box, majorScale, Textarea } from '@segment/react-ui-library'
import CHURN_CHOICES from './ChurnSurveyConstants'
import getProp from '@f/get-prop'

const ChurnSurvey = props => {
  const { onClose, onConfirm, onChange, title, copy, confirmText, churnSurvey, disabled } = props
  return (
    <Overlay visible>
      <Confirm
        title={title}
        confirmText={confirmText}
        onClose={onClose}
        onConfirm={onConfirm}
        disabled={disabled}
        skipCloseOnConfirm
        isDangerous>
        {copy}
        <form>
          {CHURN_CHOICES.map((radio, index) => {
            const isChecked = churnSurvey.parentValue === radio.value
            return (
              <span key={`${radio.value}-${index}`}>
                <Radio
                  name='parent'
                  value={radio.value}
                  data-label={radio.label}
                  onChange={() => onRadioSelect(null, radio)}
                  checked={isChecked}>
                  {radio.label}
                </Radio>
                {churnSurvey.parentValue === 'other' && radio.value === 'other' &&
                  <Textarea
                    width={majorScale(50)}
                    name='other'
                    placeholder='Let us know why (in at least 20 characters)'
                    onChange={e => onRadioSelect(e.target.value, radio)}
                    defaultValue={churnSurvey.other} />
                }

                {/* only show nested radio buttons if they exist AND parent is selected */}
                {!!radio.children && isChecked &&
                  <Box marginLeft={majorScale(3)}>
                    {radio.children.map((child, index) => {
                      return (
                        <span key={`child-${radio.value}-${index}`}>
                          <Radio
                            name={`child-${radio.value}`}
                            value={child.value}
                            data-label={child.label}
                            onChange={() => onRadioSelect(null, radio, child)}
                            checked={churnSurvey.childValue === child.value}>
                            {child.label}
                          </Radio>
                          {churnSurvey.childValue === 'other' && child.value === 'other' &&
                            <Textarea
                              width={majorScale(50)}
                              name='other'
                              placeholder='Let us know why (in at least 20 characters)'
                              onChange={e => onRadioSelect(e.target.value, radio, child)}
                              defaultValue={churnSurvey.other} />
                          }
                        </span>
                      )
                    })}
                  </Box>
                }
              </span>
            )
          })}
        </form>
      </Confirm>
    </Overlay>
  )

  function onRadioSelect (other, parent, child) {
    const newChurnSurvey = {
      parentValue: getProp('value', parent),
      parentLabel: getProp('label', parent),
      childValue: getProp('value', child) || null,
      childLabel: getProp('label', child) || null,
      other: other || null,
      surveyComplete: isSurveyComplete(other, parent, child)
    }
    onChange(newChurnSurvey)
  }

  function isSurveyComplete (other, parent, child) {
    // surveyComplete is true when user has selected:

    // parent radio, "other" child radio, & completed "other" textarea
    if (!!child && child.value === 'other') return !!other && other.length > 19

    // "other" parent radio & completed the parent other's textarea
    if (parent.value === 'other') return !!other && other.length > 19

    // parent radio that has no children
    if (!parent.children) return true

    // parent radio and non-"other" child radio,
    return !!child
  }
}

ChurnSurvey.defaultProps = {
  copy: 'Help us understand your decision with a brief survey below.'
}

ChurnSurvey.propTypes = {
  churnSurvey: PropTypes.object.isRequired,
  confirmText: PropTypes.string.isRequired,
  copy: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired
}

ChurnSurvey.displayName = 'ChurnSurvey'

export default ChurnSurvey



// WEBPACK FOOTER //
// ./ui/ChurnSurvey.js